import { useEffect } from 'react';
import { observer } from 'mobx-react';
import { Box, Grid, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { createSelectField, createTextField } from '@roc/ui';
import { useLoanVendorStore } from '../../hooks/userLoanVendorStore';
import { LoanVendorSearchBar } from '../loan/loanVendorSearchBar';
import { CounterPartyExpensesTab } from '../../types/types';

const useStyles = makeStyles(() => ({
  container: {
    padding: '10px',
    paddingTop: '20px',
    paddingBottom: '20px',
  },
  field: {
    padding: '10px',
  },
  button: {
    width: '160px',
    marginTop: '10px',
    marginRight: '10px',
  },
}));

const ROLE_LABELS = {
  closingAttorney: 'Closing Attorney',
  vendorAgent: 'Vendor Agent',
};

export const CreateVendorUserForm = observer(() => {
  const { loanVendorStore } = useLoanVendorStore();
  const { vendorUserFormStore, selectedTab } = loanVendorStore;
  const classes = useStyles();

  useEffect(() => {
    loanVendorStore.getVendors();
  }, []);

  useEffect(() => {
    if (selectedTab === CounterPartyExpensesTab.VENDOR_USERS) {
      loanVendorStore.loadVendorUserRoles();
    }
  }, [loanVendorStore.loanVendor]);

  return (
    <Box>
      <Grid container direction="row" className={classes.container}>
        <Grid item sm={4} xs={12}>
          <LoanVendorSearchBar />
        </Grid>
        <Grid item xs={12} style={{ marginBottom: 24, marginTop: 16 }}>
          <Box width={'100%'} height={'1px'} bgcolor={'#ddd'} mt={1}></Box>
        </Grid>
        <Grid item xs={12} sm={6} className={classes.field}>
          {createTextField({
            label: 'First Name',
            fieldName: 'firstName',
            testId: 'firstName',
            store: vendorUserFormStore,
          })}
        </Grid>
        <Grid item xs={12} sm={6} className={classes.field}>
          {createTextField({
            label: 'Last Name',
            fieldName: 'lastName',
            testId: 'lastName',
            store: vendorUserFormStore,
          })}
        </Grid>
        <Grid item xs={12} sm={6} className={classes.field}>
          {createTextField({
            label: 'Email',
            fieldName: 'emailAddress',
            testId: 'emailAddress',
            store: vendorUserFormStore,
          })}
        </Grid>
        <Grid item xs={12} sm={6} className={classes.field}>
          {createSelectField({
            label: 'Role',
            fieldName: 'role',
            testId: 'role',
            store: vendorUserFormStore,
            options: loanVendorStore.vendorUserRoles.map(role => ({
              label: ROLE_LABELS[role] ?? role,
              value: role,
            })),
          })}
        </Grid>
        <Grid item xs={12}>
          <Box display="flex" justifyContent="flex-end">
            <Button
              variant="contained"
              color="primary"
              className={classes.button}
              disabled={!loanVendorStore.loanVendor}
              onClick={() => loanVendorStore.saveVendorUser()}
            >
              Create User
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
});
